import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from 'src/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      height: 121,
      gap: 16,
      borderRadius: 8,
      padding: 14,
      boxShadow: 'none',

      '& .MuiCardHeader-root': {
        padding: 0,
      },

      '& .MuiCardHeader-title': {
        fontWeight: 400,
        fontSize: 14,
        marginBottom: 0,
        textAlign: 'left',
      },

      '& .MuiCardContent-root': {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    buttonGroup: {
      boxShadow: 'none',
      borderRadius: '50%',
    },
    button: {
      padding: 7,
      minWidth: 24,
    },
    menuList: {
      textAlign: 'left',
    },
    menuItem: {
      height: 56,
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,
    },
    menuItemHierarchy: {
      height: 56,
      fontWeight: 600,
      fontSize: 16,
      color: variables.richBlack,

      '& svg': {
        marginLeft: '-13px',
      },
    },
    menuItemText: {
      marginInlineStart: 5,
    },
    menuTitle: {
      fontWeight: 700,
      fontSize: 12,
      paddingLeft: 16,
      paddingRight: 16,
    },
    content: {
      fontWeight: 600,
      fontSize: 18,
      color: variables.richBlack,
      textAlign: 'left',
    },
    balance: {
      backgroundColor: variables.mintWhite,
    },
    clients: {
      backgroundColor: variables.beige,
    },
    ta: {
      backgroundColor: variables.nyanza,
    },
    links: {
      backgroundColor: variables.purpleWhite,
    },
    cashback: {
      backgroundColor: variables.blueishWhite,
    },
    number: {
      fontSize: 32,
      fontWeight: 600,
      color: variables.richBlack,
      textAlign: 'left',
    },
    decimal: {
      fontSize: 18,
    },
    padding: {
      paddingTop: 6,
      cursor: 'pointer',
    },
    bottomContent: {
      textAlign: 'left',
      paddingRight: 4,
      paddingTop: 4,
      display: 'flex',
    },
    bottomContentItem: {
      borderRadius: 4,
      marginRight: 4,
      height: 19,
      paddingLeft: 4,
      paddingRight: 4,
      backgroundColor: '#030C210D',
    },
    title: {
      minWidth: 0,
      cursor: 'default',
    },
  }),
);
